import { render } from "./BuyASubscriptionModal.vue?vue&type=template&id=73404dd2&scoped=true"
import script from "./BuyASubscriptionModal.vue?vue&type=script&lang=js"
export * from "./BuyASubscriptionModal.vue?vue&type=script&lang=js"

import "./BuyASubscriptionModal.vue?vue&type=style&index=0&id=73404dd2&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73404dd2"]])

export default __exports__